export const i18nDefaultMessages = {
  arraylayout: {
    add: 'Add',
    delete: 'Delete',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    dialogTitle: 'Delete {{ element }}?',
    dialogText: 'The element will be deleted.',
    dialogConfirm: 'Delete',
    dialogCancel: 'Cancel',
  },
};
